import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { MkpItemContainerModel } from '../../../../../models/aggregates/mkp/mkp-item-container.model';
import { MkpItemImageHdrContainerModel } from '../../../../../models/aggregates/mkp/mkp-item-image-hdr-container.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class MkpItemService extends BaseApiTemplateService<MkpItemContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "items/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  readonly endpointPathGeneric = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MKP_PREFIX + "items/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = this.endpointPathGeneric + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getImageItemFile(imageHdrGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/image-file/" + imageHdrGuid;
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  addImageHdr(formData: FormData, hdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-images/' + hdrGuid;
    return this.httpClient.post<ApiResponseModel<MkpItemImageHdrContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  replaceImageHdr(formData: FormData, imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-images/' + imageHdrGuid;
    return this.httpClient.put<ApiResponseModel<MkpItemImageHdrContainerModel>>(url, formData, this.getHttpHeader(visa));
  }

  deleteImageHdr(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/image-file/' + imageHdrGuid;
    return this.httpClient.delete<ApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }

  publishItem(itemHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpointPathGeneric;
    }
    const url = this.apiUrl + 'publish-item/' + itemHdrGuid + "/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    return this.httpClient.get<ApiResponseModel<any>>(url, this.getHttpHeader(visa));
  }
}